import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Container } from 'react-bootstrap';
var Footer = function () {
    var currentYear = new Date().getFullYear();
    return (_jsx("footer", { className: "footer", children: _jsx(Container, { children: _jsxs("p", { children: ["\u00A9 ", currentYear, " KADD Technologies. All rights reserved."] }) }) }));
};
export default Footer;
